enum TransactionTypes {
    AUCTION = 'Auction',
    CART = 'Cart',
    BIN = 'Bin',
    PURCHASE_OFFER_ON_ACTIVE = 'PurchaseOfferOnActive',
    PURCHASE_OFFER_ON_ENDED = 'PurchaseOfferOnEnded',
}

export default TransactionTypes;
